/**
 * StoreModal
 */
function loadStoreModal() {
    const storeRedirect = document.getElementById("StoreRedirect");
    const modalOverlay = document.getElementById("ModalOverlay")

    function showModal(event) {
        // Prevent unwanted page scrolling behavior
        event.preventDefault();
        event.stopPropagation();

        storeRedirect && storeRedirect.classList.add("active");
        modalOverlay && modalOverlay.classList.add("active");
    }

    function closeModal() {
        storeRedirect && storeRedirect.classList.remove("active")
        modalOverlay && modalOverlay.classList.remove('active')
    }

    document.querySelectorAll(".header__region").forEach((element) => {
        element.addEventListener("click", showModal)
    })

    document.querySelector(".modal__close--button").addEventListener("click", closeModal)

    // close modal when click outside
    document.addEventListener('click', function (event) {
        if (modalOverlay && 
            modalOverlay.classList.contains('active') && 
            !storeRedirect.contains(event.target) && 
            !event.target.closest('.header__region')) {
            closeModal();
        }
    });

    document.querySelectorAll(".redirect-btn").forEach(function (button) {
        button.addEventListener("click", handleRedirectClick);
    });
}

function handleRedirectClick(e) {
    const redirect = e.currentTarget.getAttribute("data-redirect-url");
    const redirectVariable = getRedirectVariable();

    switch (redirect) {
        case "AU":
            window.location.href = "https://" + "www.beginningboutique.com.au" + window.location.pathname + redirectVariable;
            break;
        case "NZ":
            window.location.href = "https://" + "www.beginningboutique.co.nz" + window.location.pathname + redirectVariable;
            break;
        case "US":
            window.location.href = "https://" + "www.beginningboutique.com" + window.location.pathname + redirectVariable;
            break;
        default:
            break;
    }
}

function getRedirectVariable() {
    if (window.location.href.includes("paidsocial")) {
        return "?utm_source=paidsocial";
    } else if (window.location.href.includes("gclid")) {
        return "?utm_source=gclid";
    } else {
        return "?utm_source=redirectIP";
    }
}

document.addEventListener('DOMContentLoaded', loadStoreModal)
